
<p-card styleClass="mt-2">
    <div class="card dashboardTable">
        <p-toolbar styleClass="mb-4">
            <ng-template pTemplate="left">
                <!-- <button pButton icon="pi pi-fw pi-plus" label="Add Bank Details" (click)="openNew()"
                    class="p-button-success"></button> -->
                <!-- <button pButton pRipple  icon="pi pi-trash" class="ml-4 p-button-danger" (click)="deleteSelectedProducts()" [disabled]="!selectedBankAccounts || !selectedBankAccounts.length"></button> -->
            </ng-template>
            <ng-template pTemplate="right">
                <!-- <p-fileUpload accept=".jpeg,.pdf,.jpg" mode="basic" [maxFileSize]="5000000" label="Import" chooseLabel="Import" class="mr-2 inline-block"></p-fileUpload> -->
                <button (click)="menu.toggle($event)" pButton pRipple label="{{'EXPORT'| translate}}" icon="pi pi-upload"
                    class="p-button-help"></button>
               
                <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
            </ng-template>    
        </p-toolbar>
        <p-table #miSurvey [value]="pondData"  dataKey="AppId_ProgID"
        [rows]="10"
        [paginator]="true" [globalFilterFields]="[
        'UserId',
		'Date',
		'District',
		'Applicant_Type',
		'PVStage1',
		'PVStage1_MR',
        'PVStage2',
        'PVStage2_MR',
		'PVStage3',
		'PVStage3_MR',

        ]" responsiveLayout="scroll" [rowHover]="true" dataKey="Scheme_Specific_Id"
        currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
        [showCurrentPageReport]="true">
        <ng-template pTemplate="caption">
            <div class="flex align-items-center justify-content-between">
                <h5 class="m-0">{{'DA_POND_REPORT'| translate}}</h5>
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text"
                        (input)="miSurvey.filterGlobal($any($event.target).value, 'contains')"
                        placeholder="{{'SEARCH'| translate}}" />
                </span>
            </div>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                             
                <th pSortableColumn="UserId">{{'USER_ID'| translate}}
                    <p-columnFilter type="text" field="UserId" display="menu"></p-columnFilter>
                    <p-sortIcon field="UserId"></p-sortIcon>
                </th>
                <th pSortableColumn="Date_filter">{{'DATE'| translate}}
                    <p-columnFilter type="text" field="Date_filter" display="menu"></p-columnFilter>
                    <p-sortIcon field="Date"></p-sortIcon>
                </th>
                <th pSortableColumn="District">{{'DISTRICT'| translate}}
                    <p-columnFilter type="text" field="District" display="menu"></p-columnFilter>
                    <p-sortIcon field="District"></p-sortIcon>
                </th>
                <th pSortableColumn="Applicant_Type">{{'APPLICATION_TYPE'| translate}}
                    <p-columnFilter type="text" field="Applicant_Type" display="menu"></p-columnFilter>
                    <p-sortIcon field="Applicant_Type"></p-sortIcon>
                </th>
                <th pSortableColumn="PVStage1">{{'PV_STAGE1'| translate}}
                    <p-columnFilter type="text" field="PVStage1" display="menu"></p-columnFilter>
                    <p-sortIcon field="PVStage1"></p-sortIcon>
                </th>
                <th pSortableColumn="PVStage1_MR">{{'PV_STAGE1_MR'| translate}}
                    <p-columnFilter type="text" field="PVStage1_MR" display="menu"></p-columnFilter>
                    <p-sortIcon field="PVStage1_MR"></p-sortIcon>
                </th>
                <th pSortableColumn="PVStage2">{{'PV_STAGE2'| translate}}
                    <p-columnFilter type="text" field="PVStage2" display="menu"></p-columnFilter>
                    <p-sortIcon field="PVStage2"></p-sortIcon>
                </th>
                <th pSortableColumn="PVStage2_MR">{{'PV_STAGE2_MR'| translate}}
                    <p-columnFilter type="text" field="PVStage2_MR" display="menu"></p-columnFilter>
                    <p-sortIcon field="PVStage2_MR"></p-sortIcon>
                </th>
                <th pSortableColumn="PVStage3">{{'PV_STAGE3'| translate}}
                    <p-columnFilter type="text" field="PVStage3" display="menu"></p-columnFilter>
                    <p-sortIcon field="PVStage3"></p-sortIcon>
                </th>
                <th pSortableColumn="PVStage3_MR">{{'PV_STAGE3_MR'| translate}}
                    <p-columnFilter type="text" field="PVStage3_MR" display="menu"></p-columnFilter>
                    <p-sortIcon field="PVStage3_MR"></p-sortIcon>
                </th>
            
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-pondData>
            <tr>
                <td>{{pondData.UserId}}</td>
                <td>{{pondData.Date_filter}}</td>
                <td>{{pondData.District}}</td>
                <td>{{pondData.Applicant_Type}}</td>
                <td>{{pondData.PVStage1}}</td>
                <td>{{pondData.PVStage1_MR}}</td>
                <td>{{pondData.PVStage2}}</td>
                <td>{{pondData.PVStage2_MR}}</td>
                <td>{{pondData.PVStage3}}</td>
                <td>{{pondData.PVStage3_MR}}</td>
                
            </tr>
        </ng-template>
    
        </p-table>
    </div>
    </p-card>